import { useNavigate } from "react-router-dom";
import { Button, Modal, Typography } from "@/components/atoms";
import { useOperator } from "@/hooks";

interface VehicleLimitReachedModalProps {
  isOpen: boolean;
  onClose: () => void;
  limit: number;
}

export const VehicleLimitReachedModal = ({ isOpen, onClose, limit }: VehicleLimitReachedModalProps) => {
  const navigate = useNavigate();
  const { id: operatorId } = useOperator();

  const handleUpgrade = () => {
    navigate(`/operator/${operatorId}/payments/subscriptions/subscription-plan`);
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="Vehicle limit reached"
      description={`You've reached the maximum of ${limit} vehicles allowed on your current plan.`}
      variant="web-small"
      renderButtons={() => (
        <>
          <Button variant="tertiary" size="md" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" size="md" onClick={handleUpgrade}>
            Upgrade plan
          </Button>
        </>
      )}
    >
      <Typography variant="paragraph" className="text-neutral-dark-gray">
        To add another vehicle, you&apos;ll need to archive an existing one or upgrade your plan.
      </Typography>
    </Modal>
  );
};
